import css from './tabListB.module.scss';
import { useGlobal } from '@/utils/useGlobal';
import SwiperA from './swiperA';
import KitH from './kitH';
import KitI from './kitI';
import KitK from './kitK';
import KitL from './kitL';
import KitM from './kitM';
import ListC from './listC';
import ListD1 from './listD/listD1';
import ListD2 from './listD/listD2';
import Home1 from './home1';
import Home2 from './home2';
import Home3 from './home3';
import Home4 from './home4';

export default function TabListC({ callBack }: any) {
    const { useLang } = useGlobal();
    const { t } = useLang('ecoflowpowerkitsseries');

    const swiperAData = {
        title0: t('presale.product.tab_listC_title0'),
        title1: t('presale.product.tab_listC_title1'),
        title2: t('presale.product.tab_listC_title2'),
        list: [
            {
                // i18n: 'listC_1',
                src: ['/video/mm100/home1_h5.webm', '/video/mm100/home1_h5.mp4'],
                class: 'offGrid-video-1',
            },
            // {
            //     // i18n: 'listC_2',
            //     src: ['/video/mm100/home2_h5.webm', '/video/mm100/home2_h5.mp4'],
            //     class: 'offGrid-video-2',
            // },
            // {
            //     i18n: 'listC_3',
            //     src: ['/video/mm100/home3.webm', '/video/mm100/home3.mp4'],
            //     class: 'offGrid-video-3'
            // }
        ],
    };

    return (
        <div className={`${css.tabListC} tabListC`}>
            <Home1 />
            <SwiperA data={swiperAData} tabHide customClass="last-swiper" pagingClass="right-paging" tab="home" />
            <Home2 />
            <Home3 />
            <Home4 />
            <KitH type="home" customClass="kitH-home" videoClass1="home-video1" videoClass2="home-video2" />
            <KitK />
            <KitI type="home" />
            {/* <ListB callBack={callBack} customClass="listB-home" type="home" /> */}
            <KitL callBack={callBack} active="kitL" />
            <KitM callBack={callBack} active="kitM" />
            {/*<ImgShowCard />*/}
            <ListC callBack={callBack} type="home" active="listC" />
            <ListD1 callBack={callBack} active="listD1" />
            <ListD2 callBack={callBack} active="listD2" />
        </div>
    );
}
